// extracted by mini-css-extract-plugin
module.exports = {"stats-body":"StatsBlocks_stats-body__mMR3c","block":"StatsBlocks_block__2RHMh","value":"StatsBlocks_value__2J5Jz","label":"StatsBlocks_label__LfoiG"};